import { ArrowRight, ArrowLeft, Home } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

// Floating back pill — anchored to the viewport top-start so it stays in
// front of the user on any scroll depth. Hidden on main tabs where the
// bottom-bar already handles navigation. On the first page of a session it
// turns into a home shortcut instead.
const HIDDEN_PATHS = new Set(["/", "/orders", "/favorites", "/my-account", "/dashboard", "/shop-dashboard", "/delivery-dashboard", "/admin", "/taxi-driver"]);

export default function FloatingBackPill() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  if (HIDDEN_PATHS.has(pathname)) return null;
  const dir = typeof document !== "undefined" ? document.documentElement.dir : "ltr";
  const canBack = typeof window !== "undefined" && window.history.length > 1;
  const Arrow = dir === "rtl" ? ArrowRight : ArrowLeft;
  const go = () => (canBack ? nav(-1) : nav("/"));
  return (
    <button
      onClick={go}
      className="fixed top-[calc(env(safe-area-inset-top)+4rem)] start-3 z-[55] h-10 min-w-10 px-3 rounded-full bg-background/95 backdrop-blur border-2 border-primary/50 shadow-lg flex items-center gap-1.5 text-sm font-black hover:scale-[1.03] active:scale-95 transition"
      data-testid="floating-back-pill"
      aria-label={canBack ? "رجوع" : "الرئيسية"}
    >
      {canBack ? <Arrow className="size-4" /> : <Home className="size-4" />}
      <span>{canBack ? "رجوع" : "الرئيسية"}</span>
    </button>
  );
}
